module.exports = __webpack_public_path__ + "img/puntajenacional.99dc6084.png";